import { Autocomplete } from 'components/form'
import React from 'react'

import PropTypes from 'prop-types'

import { API, destinationSearchPath } from 'app/apiService'

import styles from './destinationControl.module.scss'

const DestinationOption = ({ option, ...rest }) => {
  return (
    <div className={styles.destinationOption} {...rest}>
      <label>{option.label}</label>
      <abbr>{option.airportCode || option.countryCode}</abbr>
    </div>
  )
}

DestinationOption.propTypes = {
  option: PropTypes.shape({
    countryCode: PropTypes.string,
    airportCode: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    cityName: PropTypes.string,
  }),
}

const DestinationControl = ({ label, ...rest }) => {
  const getDestinations = (searchToken) => {
    return (
      API.get(destinationSearchPath(searchToken))
        // filter out duplicates
        .then((res) =>
          res.reduce((acc, dest) => {
            acc[dest.value] = dest

            return acc
          }, {})
        )
        .then((res) => Object.values(res))
    )
  }

  return (
    <Autocomplete
      label={label}
      OptionComp={DestinationOption}
      displayBy={(opt) => `${opt.cityName} (${opt.airportCode || opt.countryCode})`}
      optionsResolver={getDestinations}
      emptyLabel="Nothing found"
      {...rest}
    ></Autocomplete>
  )
}

DestinationControl.displayName = 'DestinationControl'

DestinationControl.propTypes = {
  label: PropTypes.string,
}

export { DestinationControl }
